import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import "./Billing.css";
import Overview from "./Tabs/Overview";
import Plans from "./Tabs/Plans";

const Billing = () => {
  const [selectedItem, setSelectedItem] = useState(0);

  const userSlugData = useSelector(
    (state) => state.SettingsUserProfileData.slug
  );
  const userProfileData = useSelector(
    (state) => state.SettingsUserProfileData?.user_profile_data
  );

  const MenuItem = [
    "Overview",
    userSlugData?.includes("purchase-new-workspace") ? "Plans " : null,
  ].filter((item) => item);

  const renderSelectedComponent = () => {
    switch (selectedItem) {
      case 0:
        return <Overview />;
      default:
        return <Plans />;
    }
  };
  useEffect(() => {
    if (userProfileData?.subscription === null) {
      setSelectedItem(1);
    }
  });

  const tabNames = ["Overview", "Plans "];
  return (
    <div className="main-resource-cont">
      <div className="resource-head">
        <div className="head-port">
          <svg
            className="mon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity="0.4"
              d="M19.3 7.91949V13.0695C19.3 16.1495 17.54 17.4695 14.9 17.4695H6.10995C5.65995 17.4695 5.22996 17.4295 4.82996 17.3395C4.57996 17.2995 4.33996 17.2295 4.11996 17.1495C2.61996 16.5895 1.70996 15.2895 1.70996 13.0695V7.91949C1.70996 4.83949 3.46995 3.51953 6.10995 3.51953H14.9C17.14 3.51953 18.75 4.46953 19.18 6.63953C19.25 7.03953 19.3 7.44949 19.3 7.91949Z"
              fill="#292D32"
            />
            <path
              d="M22.3001 10.9206V16.0706C22.3001 19.1506 20.5401 20.4706 17.9001 20.4706H9.11008C8.37008 20.4706 7.70009 20.3706 7.12009 20.1506C5.93009 19.7106 5.12008 18.8006 4.83008 17.3406C5.23008 17.4306 5.66008 17.4706 6.11008 17.4706H14.9001C17.5401 17.4706 19.3001 16.1506 19.3001 13.0706V7.92059C19.3001 7.45059 19.2601 7.03062 19.1801 6.64062C21.0801 7.04063 22.3001 8.38059 22.3001 10.9206Z"
              fill="#292D32"
            />
            <path
              d="M10.4999 13.1394C11.9579 13.1394 13.1399 11.9574 13.1399 10.4994C13.1399 9.04136 11.9579 7.85938 10.4999 7.85938C9.04185 7.85938 7.85986 9.04136 7.85986 10.4994C7.85986 11.9574 9.04185 13.1394 10.4999 13.1394Z"
              fill="#292D32"
            />
            <path
              d="M4.77979 8.25C4.36979 8.25 4.02979 8.59 4.02979 9V12C4.02979 12.41 4.36979 12.75 4.77979 12.75C5.18979 12.75 5.52979 12.41 5.52979 12V9C5.52979 8.59 5.19979 8.25 4.77979 8.25Z"
              fill="#292D32"
            />
            <path
              d="M16.21 8.25C15.8 8.25 15.46 8.59 15.46 9V12C15.46 12.41 15.8 12.75 16.21 12.75C16.62 12.75 16.96 12.41 16.96 12V9C16.96 8.59 16.63 8.25 16.21 8.25Z"
              fill="#292D32"
            />
          </svg>
          <h3>Manage Subscription</h3>
        </div>
      </div>
      <div className="billing-tabs">
        <div className="billing-content">
          <div className="routing-user-access">
            {MenuItem.map((item, index) => (
              <div
                key={index}
                className={
                  index === selectedItem
                    ? "user-access-route-item"
                    : "setting-item"
                }
                onClick={() => {
                  setSelectedItem(index);
                  //gtm

                  window.dataLayer.push({
                    event: item,
                    buttonName: item,
                    userId: JSON.parse(localStorage.getItem("userDetails"))?.id,
                    clientId: JSON.parse(localStorage.getItem("userDetails"))
                      ?.client_id,
                  });
                }}
              >
                {item}
              </div>
            ))}
          </div>
          <div className="user-access-content">{renderSelectedComponent()}</div>

          {/* <StepTabs size={"large "} tabNames={tabNames}>
              <Overview/>
              <Plans/>
              
         


          </StepTabs> */}
        </div>
      </div>
    </div>
  );
};
export default Billing;
